<div *ngIf="sent">
  <h2>
    Your request has been sent
  </h2>
  <button mat-flat-button
    color="primary"
    (click)="reset.emit()">Send Another</button>
</div>